import React, { useState, useEffect } from 'react';
import styles from "./admin.module.css";
import {
  addUserPermissions,
  removeUserPermissions,
  findAllUsers,
  findUserByMail,
  updateUserInfo,
} from '../../Services/auth.service.js'
import Admin from "../../assets/ic_admin_icon.svg";
import Clipboard from '../../assets/ic_copy_clipboard.svg'
import validator from 'validator'
import DefaultButton from "../../Components/forms/DefaultButton"
import AdminDialog from '../../Components/AdminDialog/AdminDialog';
import RoundButton from '../../Components/RoundButton/RoundButton';



const AdminMenu = () => {
  const userDefaultValues = {
    email: '',
    permission: 'padrao',
    modules: {
      dashboards: '',
      oferta_contextual: '',
      sherlock: '',
      web_push: '',
    }
  }

  const [adminAddMenu, setAdminAddMenu] = React.useState(true)
  const [adminEditMenu, setAdminEditMenu] = React.useState(false)
  const [adminRemoveMenu, setAdminRemoveMenu] = React.useState(false)
  const [adminListMenu, setAdminListMenu] = React.useState(false)

  const [userDialog, setUserDialog] = React.useState(false)

  const [userData, setUserData] = React.useState(userDefaultValues)
  const [userId, setUserId] = React.useState(undefined)
  const [selectedUser, setSelectedUser] = React.useState('')

  const addRef = React.useRef(null)
  const editRef = React.useRef(null)
  const removeRef = React.useRef(null)
  const listRef = React.useRef(null)

  const adminNav = () => {
    return (
      <>
        <div className={styles.adminNav} >
          <div ref={addRef}
            className={`${styles.navItem} ${styles.active}`}
            onClick={() => { changeMenu('add') }}>
            Adicionar usuário
          </div>
          <div ref={editRef}
            className={styles.navItem}
            onClick={() => { changeMenu('edit') }}>
            Editar usuário
          </div>
          <div ref={removeRef}
            className={styles.navItem}
            onClick={() => { changeMenu('remove') }}>
            Remover usuário
          </div>
          <div ref={listRef}
            className={styles.navItem}
            onClick={() => {
              changeMenu('list');
              findAllUser(document.getElementById('email').value);
            }}>
            Listar usuários
          </div>
        </div>
      </>
    )
  }

  const changeMenu = (menu) => {
    setAdminAddMenu(false)
    setAdminEditMenu(false)
    setAdminRemoveMenu(false)
    setAdminListMenu(false)
    addRef.current.classList.remove(styles.active);
    editRef.current.classList.remove(styles.active);
    removeRef.current.classList.remove(styles.active);
    listRef.current.classList.remove(styles.active);

    setEmailError(false)
    setUserData(userDefaultValues)
    setSelectedUser('')

    switch (menu) {
      case 'add':
        setAdminAddMenu(true)
        setUserData(userDefaultValues)
        addRef.current.classList.add(styles.active);
        break

      case 'edit':
        setAdminEditMenu(true)
        setUserData(userDefaultValues)
        editRef.current.classList.add(styles.active);
        break

      case 'remove':
        setAdminRemoveMenu(true)
        setUserData(userDefaultValues)
        removeRef.current.classList.add(styles.active);
        break

      case 'list':
        setAdminListMenu(true)
        listRef.current.classList.add(styles.active);
        break

      default:
        break
    }
  }

  const [emailError, setEmailError] = useState('')
  const requiresEmail = (e) => {
    if (validator.isEmpty(e.target.value))
      return setEmailError('Digite um email')
    else if (!validator.isEmail(e.target.value))
      return setEmailError('Email inválido')
    return setEmailError(false)
  }
  const isEmail = (e) => {
    if (validator.isEmail(e.target.value))
      return setEmailError(false)
    else if (validator.isEmpty(e.target.value))
      return setEmailError(false)
    return setEmailError('Email inválido')
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    switch (type) {
      case 'email':
        setUserData({
          [name]: value,
          permission: userData.permission,
          modules: userData.modules,
          changePassword: true
        })
        break
      case 'checkbox':
        if (checked) {
          setUserData({
            email: userData.email,
            [name]: checked ? 'admin' : 'padrao',
            modules: {
              dashboards: 'leitura',
              oferta_contextual: 'edicao',
              sherlock: 'edicao',
              web_push: 'edicao',
            },
            changePassword: true
          })
          //let userModules = Object.entries(userData.modules)
          document.querySelectorAll('[type="radio"]').forEach((e) => {
            e.disabled = true
            e.checked = false
          })
        } else {
          setUserData({
            email: userData.email,
            [name]: checked ? 'admin' : 'padrao',
            modules: userDefaultValues.modules,
            changePassword: true
          })
          document.querySelectorAll('[type="radio"]').forEach((e) => {
            e.disabled = false
            e.checked = false
          })
        }
        break
      case 'radio':
        let moduleObj = {}
        let radioArray = document.querySelectorAll('[type="radio"]:checked')
        if (radioArray.length == 3) {
          radioArray.forEach((radio) => {
            Object.assign(moduleObj, { [radio.name]: radio.value })
          })
          setUserData({
            email: userData.email,
            permission: userData.permission,
            modules: moduleObj,
            changePassword: true
          })
        }
        break
    }
  }

  function buttonValidator() {
    let userDataArray = Object.values(userData)
    let modulesArray = Object.values(userDataArray[2])
    if (
      userDataArray.includes('') ||
      modulesArray.includes('') ||
      !validator.isEmail(userData.email)
    )
      return true
    return false
  }

  function findAllUser(email = '') {
    const users = Promise.resolve(findAllUsers(email))
    users.then((user) => {
      if (user.length === 0) {
        alert('Usuário não encontrado');
      } else {
        setListUserData(user)
      }
    })
  }
  
  const [listUserData, setListUserData] = React.useState([{
    email: '',
    permission: '',
    modules: {
      dashboards: '',
      oferta_contextual: '',
      sherlock: '',
      web_push: '',
    }
  }]);

  //------------------------ Menu Add New User ---------------------------

  const menuAddNewUser = () => {
    function handleCloseDialog() {
      setUserDialog(false)
    }
    function openNewUserDialog() {
      setUserDialog(true)
    }

    if (adminAddMenu)
      return (
        <>
          <div className={`${styles.fullWidth} add-user`}>
            <div className={`${styles.row}`}>
              <h2><b>Adicionar novo usuário</b></h2>
              <div className={styles.absoluteBtn}>
                <DefaultButton
                  type={`${buttonValidator() ? 'disabled' : 'red'}`}
                  size="MD"
                  onClick={() => { openNewUserDialog() }
                  }
                  children="Adicionar"
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.inputBox}>
                <input
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Email do Usuário"
                  onChange={(e) => {
                    requiresEmail(e)
                    handleChange(e)
                  }} />
                <small className={styles.errorMsg}>{emailError}</small>
              </div>

              <div className={styles.chkbox}>
                <label for="permission">é Administrador?</label>
                <input
                  type="checkbox"
                  name="permission"
                  value="padrao"
                  onChange={(e) => {
                    handleChange(e)
                  }} />
              </div>
            </div>
            <div className={styles.hr}></div>
            <div className={styles.row}>
              <div className={styles.table}>

                <div ></div>
                <div className={styles.gridRadioCol}>Edição</div>
                <div className={styles.gridRadioCol}>Leitura</div>
                <div className={styles.gridRadioCol}>Sem Acesso</div>

                <div >Web Notification</div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="web_push" value="edicao" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="web_push" value="leitura" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="web_push" value="restrito" onChange={(e) => { handleChange(e) }} />
                </div>

                <div >Oferta Contextual</div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="oferta_contextual" value="edicao" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="oferta_contextual" value="leitura" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="oferta_contextual" value="restrito" onChange={(e) => { handleChange(e) }} />
                </div>

                <div >Sherlock</div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="sherlock" value="edicao" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="sherlock" value="leitura" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="sherlock" value="restrito" onChange={(e) => { handleChange(e) }} />
                </div>

                <div >Dashboards</div>
                <div className={`${styles.gridRadioCol}`}>
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="dashboards" value="leitura" onChange={(e) => { handleChange(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input type="radio" name="dashboards" value="restrito" onChange={(e) => { handleChange(e) }} />
                </div>
              </div>
            </div>
          </div>
          <AdminDialog
            isOpen={userDialog}
            onRequestClose={handleCloseDialog}
            data={userData}
            title="Deseja adicionar esse usuário?"
            method={addUserPermissions}
            type="add"
          />
        </>
      )

  }

  //------------------------ Menu Edit User ---------------------------

  const menuEditUser = () => {
    function handleCloseDialog() {
      setUserDialog(false)
    }
    function openEditUserDialog() {
      setUserDialog(true)
    }
    function findUser(email) {
      const users = Promise.resolve(findUserByMail(email))
      users.then((user) => {
        if (user) {
          setUserId(user.id)
          setUserData(user)
          checkRadioButtons(user)
        } else
          alert('Nenhum usuário encontrado!')
      })
    }
    function checkRadioButtons(user) {
      let validator = document.querySelectorAll('.edit-user input[type="radio"]')
      validator.forEach(e => {
        if (user.modules[e.name] == e.value)
          e.checked = true
      })
    }
    const isEqual = (
      ...objects) => objects.every(
        obj => JSON.stringify(obj) === JSON.stringify(objects[0])
      )
    function clearInput() {
      setUserData(userDefaultValues)
      document.querySelectorAll('.edit-user input')
        .forEach((e) => {
          switch (e.type) {
            case 'radio':
              e.checked = false
              break
            case 'email':
              e.value = ''
              break
            case 'checkbox':
              e.checked = false
              break
          }
        })
      setEmailError(false)
    }
    function validateSearch() {
      if (
        validator.isEmpty(userData.email) ||
        !validator.isEmail(userData.email) ||
        isEqual(userData, userDefaultValues)
      )
        return false
      return true
    }
    function handleChangeEdit(e) {
      const { name, value, type, checked } = e.target;
      switch (type) {
        case 'email':
          setUserData({
            [name]: value,
            permission: userData.permission,
            modules: userData.modules
          })
          break
        case 'checkbox':
          setUserData({
            email: userData.email,
            [name]: checked ? 'admin' : 'padrao',
            modules: userData.modules
          })
          break
        case 'radio':
          let moduleObj = {}
          let radioArray = document.querySelectorAll('[type="radio"]:checked')
          if (radioArray.length == 3) {
            radioArray.forEach((radio) => {
              Object.assign(moduleObj, { [radio.name]: radio.value })
            })
            setUserData({
              email: userData.email,
              permission: userData.permission,
              modules: moduleObj,
            })
          }
          break
      }
    }

    if (adminEditMenu)
      return (
        <>
          <div className={`${styles.fullWidth} edit-user`}>
            <div className={`${styles.row}`}>
              <h2><b>Editar usuário</b></h2>
              <div className={styles.absoluteBtn}>
                <DefaultButton
                  size="MD"
                  type={`${buttonValidator() ? 'disabled' : 'red'}`}
                  onClick={() => { openEditUserDialog() }}
                  children="Editar"
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.inputBox}>
                <input
                  type="email"
                  name="email"
                  placeholder="Email do Usuário"
                  disabled={
                    !buttonValidator()
                  }
                  onChange={(e) => {
                    requiresEmail(e)
                    handleChangeEdit(e)
                  }}
                />
                <small className={styles.errorMsg}>{emailError}</small>
              </div>
              <DefaultButton
                type={
                  isEqual(userData, userDefaultValues) ? 'disabled' : 'red'
                }
                size="XS"
                onClick={() => {
                  clearInput()
                }}
                children="Limpar"
              />
              <DefaultButton
                type={
                  validateSearch() ? 'red' : 'disabled'
                }
                size="SM"
                onClick={() => {
                  findUser(userData.email)
                }}
                children="Procurar usuário"
              />
            </div>
            <div className={styles.row}>
              <div className={styles.chkbox} style={{ marginLeft: '11px' }}>
                <label for="permission">é Administrador?</label>
                <input
                  type="checkbox"
                  name="permission"
                  value="padrao"
                  checked={(userData.permission == 'admin') ? true : false}
                  disabled={
                    buttonValidator()
                  }
                  onChange={(e) => {
                    handleChangeEdit(e)
                  }} />
              </div>
            </div>
            <div className={styles.hr}></div>
            <div className={styles.row}>
              <div className={styles.table}>

                <div ></div>
                <div className={styles.gridRadioCol}>Edição</div>
                <div className={styles.gridRadioCol}>Leitura</div>
                <div className={styles.gridRadioCol}>Sem Acesso</div>

                <div >Web Notification</div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="web_push"
                    disabled={
                      buttonValidator()
                    }
                    value="edicao"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="web_push"
                    disabled={
                      buttonValidator()
                    }
                    value="leitura"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="web_push"
                    disabled={
                      buttonValidator()
                    }
                    value="restrito"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>

                <div >Oferta Contextual</div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="oferta_contextual"
                    disabled={
                      buttonValidator()
                    }
                    value="edicao"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="oferta_contextual"
                    disabled={
                      buttonValidator()
                    }
                    value="leitura"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="oferta_contextual"
                    disabled={
                      buttonValidator()
                    }
                    value="restrito"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>

                <div >Sherlock</div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="sherlock"
                    disabled={
                      buttonValidator()
                    }
                    value="edicao"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="sherlock"
                    disabled={
                      buttonValidator()
                    }
                    value="leitura"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="sherlock"
                    disabled={
                      buttonValidator()
                    }
                    value="restrito"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>

                <div >Dashboards</div>
                <div className={`${styles.gridRadioCol}`}>

                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="dashboards"
                    disabled={
                      buttonValidator()
                    }
                    value="leitura"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
                <div className={`${styles.gridRadioCol}`}>
                  <input
                    type="radio"

                    name="dashboards"
                    disabled={
                      buttonValidator()
                    }
                    value="restrito"
                    onChange={(e) => { handleChangeEdit(e) }} />
                </div>
              </div>
            </div>
          </div>
          <AdminDialog
            isOpen={userDialog}
            onRequestClose={handleCloseDialog}
            data={userData}
            dataId={userId}
            title="Deseja editar esse usuario?"
            method={updateUserInfo}
            type="update"
          />
        </>
      )
  }

  //------------------------ Menu Remove User ---------------------------

  const menuRemoveUser = () => {

    function handleCloseDialog() {
      setUserDialog(false)
    }

    function openRemoveDialog() {
      setUserDialog(true)
    }

    function saveToClipboard(text) {
      navigator.clipboard.writeText(text)
    }

    if (adminRemoveMenu)
      return (
        <>
          <div className={`${styles.fullWidth} remove-user`}>
            <div className={`${styles.row}`}>
              <h2><b>Remover usuário</b></h2>
              <div className={styles.absoluteBtn}>
                <DefaultButton
                  type={((selectedUser.email == '' || selectedUser.email == null) ? 'disabled' : 'red')}
                  size="MD"
                  onClick={() => { openRemoveDialog() }}
                  children="Remover"
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.inputBox}>
                <input
                  type="email"
                  id="email"
                  placeholder="Email do Usuário"
                  onChange={(e) => isEmail(e)} />
                <small className={styles.errorMsg}>{emailError}</small>
              </div>
              <DefaultButton
                type="red"
                size="SM"
                onClick={() => { findAllUser(document.getElementById('email').value) }}
                children={(listUserData.length <= 1) ? "Procurar Usuário" : "Recarregar"}
              />
            </div>

            <div className={styles.hr}></div>
            <section>
              <div className={styles.tableRow}>
                <table>
                  <thead>
                    <tr>
                      <th name='adm-remove-email'>Email</th>
                      <th name='adm-remove-permissao'>Permissão</th>
                      <th name='adm-remove-radio'></th>
                    </tr>
                  </thead>
                  {listUserData
                    .map((register) => (
                      <tbody>
                        <tr>

                          <td email={register.email ? '' : false}>
                            <span>
                              {register.email}
                              <RoundButton
                                buttonSize='sm'
                                hidden={register.email ? false : true}
                                icon={Clipboard}
                                transparent={true}
                                data={register.email}
                                tooltip={true}
                                tooltipTxt='Email copiado'
                                onClick={
                                  (e) => {
                                    saveToClipboard(register.email)
                                  }
                                }
                              /></span>
                          </td>
                          <td>{register.permission.toLocaleUpperCase()}</td>
                          <td>
                            <input
                              type='radio'
                              name='user'
                              onClick={(e) => { setSelectedUser(register); }} />
                          </td>
                        </tr>
                      </tbody>
                    ))}
                </table>
              </div>
            </section>
          </div>
          <AdminDialog
            isOpen={userDialog}
            onRequestClose={handleCloseDialog}
            afterClose={findAllUser}
            data={selectedUser}
            title="Deseja remover esse usuario?"
            method={removeUserPermissions}
            type="remove"
          />
        </>
      )
  }

  //------------------------ Menu List All User ---------------------------

  const menuListUser = () => {
    const [email, setEmail] = useState("");
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    useEffect(() => {
      const validateEmail = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailRegex.test(email);
        setIsButtonDisabled(!isValid);
      };
      validateEmail();
    }, [email]);

    const handleEmailChange = (event) => {
      setEmail(event.target.value);
      isEmail(event)
    };

    const handleClearEmail = (event) => {
      setEmail(event.target.value = '');
      setTimeout(() => {
        findAllUser(document.getElementById('email').value)
      }, 100);
    };

    function saveToClipboard(text) {
      navigator.clipboard.writeText(text)
    }
    
    if (adminListMenu) {
      return (
        <>
          <div className={styles.fullWidth}>
            <div className={`${styles.row}`}>
              <h2><b>Listar usuário</b></h2>
              <div className={styles.absoluteBtn}>
                <DefaultButton
                  type={isButtonDisabled ? 'disabled' : 'red'}
                  size="MD"
                  onClick={() => { findAllUser(document.getElementById('email').value) }}
                  children={"Procurar"}
                />
              </div>
            </div>

            <div className={styles.row}>
              <div className={styles.inputBox}>
                <input
                  type="email"
                  id='email'
                  value={email}
                  onChange={handleEmailChange}
                  placeholder="Email do Usuário"
                 />
                <small className={styles.errorMsg}>{emailError}</small>
              </div>
              <DefaultButton
                size="XS"
                type={'red'}
                onClick={handleClearEmail}
                children="Limpar"
              />
            </div>

            <div className={styles.hr}></div>

            <section>
              <div className={styles.tableRow}>
                <table>
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Permissão</th>
                      <th>Web Push</th>
                      <th>Oferta Contextual</th>
                      <th>Sherlock</th>
                      <th>Dashboards</th>
                    </tr>
                  </thead>
                  {listUserData
                    .map((register) => (
                      <tbody>
                        <tr>
                          <td email={register.email ? '' : false}>
                            <span>
                              {register.email}
                              <RoundButton
                                buttonSize='sm'
                                hidden={register.email ? false : true}
                                icon={Clipboard}
                                transparent={true}
                                data={register.email}
                                tooltip={true}
                                tooltipTxt='Email copiado'
                                onClick={
                                  (e) => {
                                    saveToClipboard(register.email)
                                  }
                                }
                              /></span>
                          </td>
                          <td>{register.permission}</td>
                          <td>{register.modules.web_push}</td>
                          <td>{register.modules.oferta_contextual}</td>
                          <td>{register.modules.sherlock}</td>
                          <td>{register.modules.dashboards}</td>
                        </tr>
                      </tbody>
                    ))}
                </table>
              </div>
            </section>
          </div>
        </>
      )
    }
  }

  return (
    <section className={styles.admin}>
      <div className={styles.container}>
        <div className={styles.containerPage}>
          <div className={`${styles.header} title-page `}>
            <img src={Admin} className={styles.iconNav} />
            <h1>Administrador</h1>
          </div>
          <div className={styles.row}>
            {adminNav()}
            <div className={styles.vr}></div>
            {menuAddNewUser()}
            {menuEditUser()}
            {menuRemoveUser()}
            {menuListUser()}
          </div>
        </div>
      </div>
    </section>
  )
}
export default AdminMenu;
